import { Box, Grid, styled, Typography } from "@mui/material";
import NumberFormats from "components/NumberFormats";
import { DefaultUrlWeb } from "config/Configuration";
import React from "react";

export default function DetailsReferralModal({ detailsReferral }) {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="center">
          <Typography variant="h5" color="text.secondary" pr={2}>
            Amount
          </Typography>

          <Box display="flex">
            <img
              src={DefaultUrlWeb + detailsReferral?.coinImageUrl}
              width={"20"}
              alt={detailsReferral?.coinName}
            />
            <Typography variant="h4" fontWeight={700} px={1}>
              <NumberFormats value={detailsReferral?.amount} />
            </Typography>

            <Typography variant="h4" fontWeight={700}>
              {detailsReferral?.coinName}
            </Typography>
          </Box>
        </Box>

        <Box display="flex" flexDirection="row-reverse" py={2}>
          <Typography variant="subtitle1" color="text.secondary">
            {detailsReferral?.date} {detailsReferral?.time}
          </Typography>
        </Box>

        <BoxType>
          <Typography variant="h6" color="text.secondary">
            Type
          </Typography>

          <Typography variant="h6">{detailsReferral?.type}</Typography>
        </BoxType>
      </Grid>
    </Grid>
  );
}
const BoxType = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  direction: "ltr",
  padding: theme.spacing(1.3),
  borderTop: `0.5px solid ${theme.palette.modules.headerModules}`,
}));
